import React from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Box } from "@material-ui/core";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Tooltip from "@material-ui/core/Tooltip";
import { green } from "@material-ui/core/colors";
import PropTypes from "prop-types";

import { MATERIAL_UI_PROPS } from "../../lib/data";

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: "none",
    },
    paper: {
        padding: theme.spacing(1),
    },
}));

const MouseOverPopover = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const { numsNode, resultNode } = createCellNode(
        props.vacant,
        props?.overbookingAmount,
        props?.freeUpgradeAmount,
        props.reserved,
        props.result,
        props?.amountAsu,
    );

    let popUpContent = `Доступно ${props.vacant} Забронировано ${props.reserved}`;

    if (props?.thisQuotas) {
        popUpContent = `Доступно в АСУ ${props.amountAsu}, Доступно в онлайн ${+props.vacant + +props.overbookingAmount}, 
        Забронировано ${props.reserved}${props?.freeUpgradeAmount ? ', Бесплатный апгрейд ' + +props.freeUpgradeAmount : ''}.`;
    }

    return (
        <>
            <Box position="relative">
                <Box
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}
                >
                    {numsNode}
                </Box>
                <Box>{resultNode}</Box>
            </Box>
            <Popover
                id="mouse-over-popover"
                transitionDuration={{ enter: 600 }}
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>{popUpContent}</Typography>
            </Popover>
        </>
    );
};

// Helper functions
/**
 * Creates Cell Node
 *
 * @param {Number} outerVacant
 * @param {Number} outerReserved
 * @param {Number} overbookingAmount
 * @param {Number} freeUpgradeAmount
 * @param {Object} outerResult
 *
 * @param amountAsu
 * @return {Object}
 */

const createCellNode = (
    outerVacant,
    overbookingAmount,
    freeUpgradeAmount,
    outerReserved,
    outerResult,
    amountAsu = null,
) => {
    const resultNode = createResultNode(outerResult);
    const numsNode = (
        <>
            {amountAsu && (
                <div style={{ fontSize: "0.95rem" }}>{amountAsu}</div>
            )}
            <div style={{ fontSize: "0.95rem", position: "relative" }}>
                {+outerVacant + +overbookingAmount}
                {overbookingAmount > 0 && (
                    <span
                        style={{
                            position: "absolute",
                            top: "-30px",
                            right: "3px",
                            color: "green",
                            fontWeight: "bold",
                            fontSize: "1rem",
                        }}
                    >
                        О
                    </span>
                )}
            </div>
            <div>{outerReserved}</div>
          {freeUpgradeAmount && <div>{freeUpgradeAmount}</div>}
        </>
    );
    return { numsNode: numsNode, resultNode: resultNode };
};

/**
 * Creates icon for DataBase update result
 *
 * @param {Object} outerResult
 */

const createResultNode = (outerResult) => {
    return outerResult.success ? (
        <CheckCircleOutlineIcon
            className="indicator"
            fontSize={MATERIAL_UI_PROPS.sizes.small}
            style={{
                color: green[500],
            }}
        />
    ) : outerResult.success === false ? (
        <Tooltip title={outerResult.message}>
            <HelpOutlineOutlinedIcon
                className="indicator"
                color={MATERIAL_UI_PROPS.colors.error}
                fontSize={MATERIAL_UI_PROPS.sizes.small}
            />
        </Tooltip>
    ) : null;
};

MouseOverPopover.propTypes = {
    vacant: PropTypes.number.isRequired,
    reserved: PropTypes.number.isRequired,
    result: PropTypes.object.isRequired,
};

export default MouseOverPopover;
